import { Link } from 'react-router-dom';
import { articles } from '@/mocks/data';
import ArticleCard from '@/components/base/ArticleCard';

interface RelatedArticlesProps {
  currentId: number;
}

export default function RelatedArticles({ currentId }: RelatedArticlesProps) {
  const related = articles.filter((a) => a.id !== currentId).slice(0, 3);

  return (
    <div>
      <h3 className="text-lg font-bold text-foreground-50 font-heading mb-5">
        相关推荐
      </h3>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-3 md:gap-5">
        {related.map((article) => (
          <ArticleCard key={article.id} {...article} />
        ))}
      </div>
    </div>
  );
}